export default __webpack_public_path__ + "static/media/jenkins.680d9ffa.svg";